export const LOCAL_STORAGE_FAVOURITE_KEY = 'favorite';
export const LOCAL_STORAGE_CART_KEY = 'cart';
